const impacts = [
  {
    icon: "ri-moon-line",
    title: "Supporting the Omani Community",
    titleAr: "دعم المجتمع العماني",
    description:
      "Blue Moon Beauty Salon actively gives back to the Al Koudh community in Muscat. We partner with local charities and support women's empowerment initiatives across Oman.",
    descriptionAr: "يدعم صالون القمر الأزرق مجتمع الخوض في مسقط، ونتشارك مع الجمعيات الخيرية المحلية لدعم تمكين المرأة عبر عمان.",
    image: "https://public.readdy.ai/ai/img_res/fa0837967e4b850092a74dcc55c984ec.jpg",
    cta: "Learn More",
  },
  {
    icon: "ri-seedling-line",
    title: "Eco-Friendly Beauty in Oman",
    titleAr: "جمال صديق للبيئة في عمان",
    description:
      "We are committed to sustainable beauty practices in our Muscat salon. From eco-friendly products to waste reduction initiatives, we protect Oman's beautiful environment.",
    descriptionAr: "نحن ملتزمون بممارسات التجميل المستدامة في صالوننا بمسقط، من المنتجات الصديقة للبيئة إلى مبادرات الحد من النفايات.",
    image: "https://readdy.ai/api/search-image?query=natural%20green%20oman%20landscape%20sustainability%20eco%20beauty%2C%20lush%20nature%20photography%2C%20clean%20environment%20muscat%2C%20community%20environmental%20care%2C%20arabian%20peninsula%20nature&width=700&height=500&seq=bm_impact002&orientation=landscape",
    cta: "Our Commitment",
  },
  {
    icon: "ri-heart-line",
    title: "Bridal Joy Program — Muscat",
    titleAr: "برنامج فرحة العرائس — مسقط",
    description:
      "Our exclusive Bridal Joy Program supports brides across Muscat and Oman with special packages and consultations, making every bride's dream beauty look a reality.",
    descriptionAr: "برنامج فرحة العرائس الحصري يدعم العرائس في مسقط وعمان بباقات وإستشارات خاصة لتحقيق إطلالة أحلام كل عروس.",
    image: "https://readdy.ai/api/search-image?query=happy%20omani%20bride%20beautiful%20wedding%20makeup%20and%20hair%2C%20golden%20warm%20light%2C%20luxury%20bridal%20beauty%20salon%20muscat%20oman%2C%20joyful%20expression%2C%20traditional%20modern%20mix&width=700&height=500&seq=bm_impact003&orientation=landscape",
    cta: "Bridal Packages",
  },
];

export default function ImpactSection() {
  return (
    <section id="impact" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">
            Beyond Beauty
          </p>
          <h2
            className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Our Impact
          </h2>
          <p
            className="text-[#1a2744]/60 text-lg mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            تأثيرنا في مجتمع مسقط والخوض
          </p>
        </div>

        <div className="space-y-10 sm:space-y-12">
          {impacts.map((item, idx) => (
            <div
              key={item.title}
              className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center`}
            >
              <div className={`relative overflow-hidden h-[240px] sm:h-[300px] md:h-[320px] ${idx % 2 === 1 ? "md:order-2" : "md:order-1"}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className={idx % 2 === 1 ? "md:order-1" : "md:order-2"}>
                <div className="w-10 h-10 flex items-center justify-center mb-5">
                  <i className={`${item.icon} text-[#c6a864] text-2xl`}></i>
                </div>
                <h3
                  className="text-[#1a2744] text-xl sm:text-2xl font-light mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-[#1a2744]/60 text-sm mb-3 text-right"
                  style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
                >
                  {item.titleAr}
                </p>
                <p className="text-gray-500 text-sm leading-relaxed mb-3">{item.description}</p>
                <p
                  className="text-gray-400 text-sm leading-relaxed mb-5 text-right"
                  style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
                >
                  {item.descriptionAr}
                </p>
                <a
                  href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap cursor-pointer text-[#c6a864] text-xs tracking-[0.2em] uppercase border-b border-[#c6a864] pb-0.5 hover:text-[#b8965a] hover:border-[#b8965a] transition-colors duration-300"
                >
                  {item.cta}
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
